import { type MutationTree } from 'vuex';

import { type IPrivateContactAgreementState } from './types';

export const RECEIVE_BY_AGREEMENT = 'receiveByAgreement';

export const mutations: MutationTree<IPrivateContactAgreementState> = {
    [RECEIVE_BY_AGREEMENT](_state: IPrivateContactAgreementState, { agreementId, idList }: { agreementId: number; idList: number[] }) {
        _state.byAgreement.set(agreementId, idList);
    }
};
